export const payslipsConstants = {
  PAYSLIPS_REQUEST: 'CONTRACTOR_PAYSLIPS_REQUEST',
  PAYSLIPS_SUCCESS: 'CONTRACTOR_PAYSLIPS_SUCCESS',
  PAYSLIPS_FAILURE: 'CONTRACTOR_PAYSLIPS_FAILURE',
};
